var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnInst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-inst",
    transform: "translate(-1726 -11693)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 48,
    height: 48,
    rx: 8,
    transform: "translate(1726 11693)",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-instagram",
    "data-name": "Icon feather-instagram",
    transform: "translate(1739.479 11707.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2917",
    "data-name": "Trac\\xE9 2917",
    d: "M8.261,3H18.782a5.261,5.261,0,0,1,5.261,5.261V18.782a5.261,5.261,0,0,1-5.261,5.261H8.261A5.261,5.261,0,0,1,3,18.782V8.261A5.261,5.261,0,0,1,8.261,3Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#05bfd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2918",
    "data-name": "Trac\\xE9 2918",
    d: "M20.436,15.526a4.208,4.208,0,1,1-3.546-3.546,4.208,4.208,0,0,1,3.546,3.546Z",
    transform: "translate(-5.707 -5.668)",
    fill: "none",
    stroke: "#05bfd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2919",
    "data-name": "Trac\\xE9 2919",
    d: "M26.25,9.75h0",
    transform: "translate(-9.942 -5.015)",
    fill: "none",
    stroke: "#05bfd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInst);
export default __webpack_public_path__ + "static/media/icn-inst.d342a38c5a6a1c28fc69d7fcd0328d34.svg";
export { ForwardRef as ReactComponent };